'use client';
import { useEffect } from 'react';
import { useParams, useRouter } from 'next/navigation';

export default function ProductDeepLink() {
  const params = useParams();
  const router = useRouter();
  const slug = params?.slug as string;

  useEffect(() => {
    if (slug) {
      const searchTerm = slug.replace(/-/g, ' ');
      router.replace(`/classifieds-screen?search=${encodeURIComponent(searchTerm)}`);
    } else {
      router.replace('/classifieds-screen');
    }
  }, [slug, router]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--background)' }}>
      <div className="flex flex-col items-center gap-3">
        <div className="w-12 h-12 rounded-2xl flex items-center justify-center animate-pulse"
          style={{ background: 'rgba(0,200,83,0.12)', border: '1px solid rgba(0,200,83,0.2)' }}>
          <span className="text-2xl">🚗</span>
        </div>
        <p className="text-sm font-600 text-foreground">Loading listing...</p>
      </div>
    </div>
  );
}
